import { OdataFieldBasicOperator } from './OdataFieldBasicOperator';
import { IOdataField } from '../../IOdataField';

export class OdataFieldCeiling extends OdataFieldBasicOperator {
  constructor(field: IOdataField) {
    super(field, 'ceiling');
  }
}
